import e from "react";

var d = function d(_ref) {
  var r = _ref.title;
  return e.createElement("div", {
    className: "hg-primarynav__submenu-product-header"
  }, r);
};

export { d as MenuProductHeader };